import { EditIcon, IConUser, IconStarCircle, ProgressBar } from "@components";
import { PATH_MY_QR, PATH_USER_SETTING, enumNavigation, enumTheme } from "@configs";
import { IInfo, IMemberShipTiers } from "@interfaces";
import { selectMerchant, setDetailUser } from "@redux";
import { RenderMeta } from "@utils";
import { Avatar, Button } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled, { CSSProperties } from "styled-components";
import { BudgeButton } from "./shared";

interface IProps {
    themeColor: string;
    userInfo: IInfo | null;
    memberShipTiers: IMemberShipTiers[];
    under: enumNavigation;
    handleToggleUnder: (value: enumNavigation) => void;
    handleToggleQrCode: () => void;
    handleSwitchUserSetting: () => void;
    handleSwitchTier: () => void;
}

const styleAvatarUser: CSSProperties = {
    marginTop: "-52px",
    width: "64px",
    height: "64px",
};
const styleCircleImg: CSSProperties = {
    width: "64px",
    height: "64px",
};
export const ComponentProfile = (props: IProps) => {
    //page hook
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { themes } = useSelector(selectMerchant);
    const themeMode = themes?.themeMode || enumTheme.LIGHT;
    const merchant = useSelector(selectMerchant);
    const history = useHistory();
    //page variable
    const {
        themeColor,
        userInfo,
        memberShipTiers,
        under,
        handleToggleUnder,
        handleToggleQrCode,
        handleSwitchUserSetting,
        handleSwitchTier,
        // handleCoupon,
    } = props;

    const [tierColor, setTierColor] = useState<string>("#ffffff");

    useEffect(() => {
        let tierList = merchant?.memberShipTiers;
        let thisTier = tierList?.find(
            (x: any) => x.membershipName === userInfo?.memberTier?.tierName
        );
        setTierColor(thisTier?.color || "#ffffff");
    }, [userInfo]);

    // current membership used bath
    const currentPoint = userInfo?.totalPoints || 0;
    const currentTierPointThreshold = userInfo?.memberTier?.pointThreshold || 0;

    // next membership
    const nextTiers = memberShipTiers?.filter(
        (item) =>
            item.pointThreshold > currentPoint &&
            item._id !== userInfo?.memberTier?._id &&
            item.pointThreshold > currentTierPointThreshold
    );
    const sortNextTiers = nextTiers.sort(
        (first, second) => first.pointThreshold - second.pointThreshold
    );
    const nextTierAmount = sortNextTiers.length > 0 ? sortNextTiers[0]?.pointThreshold : 0;
    // calculate percentage of next lvl and current
    const percentage = (+currentPoint / +nextTierAmount) * 100;
    // last active profile
    // const lastUpdatedDate = userInfo?.lastActive || "";

    const handleDetail = () => {
        dispatch(setDetailUser());
    };
    const openProfileForm = () => {
        history.push(PATH_USER_SETTING);
    };

    const modeColor = themeMode === enumTheme.DARK ? "#f1f1f1" : "#000000";

    if (merchant?.advanceSettings?.advanceFeature?.isCorporateUi) {
        let elementToHide: HTMLElement | null = document.getElementById("bannersme");

        if (elementToHide) {
            elementToHide.style.display = "none";
        }
    }

    return (
        <>
            <RenderMeta title={t("meta.profile_page")} />
            <div className="background"></div>
            <div className="preview">
                <div className="avatar-layout">
                    {userInfo?.avatar ? (
                        <div
                            onClick={handleSwitchUserSetting}
                            className="circle-avatar-user-layout"
                        >
                            <Avatar
                                className="circle-avatar-user"
                                shape="circle"
                                alt="Avatar"
                                style={styleCircleImg}
                                size={62}
                                src={userInfo?.avatar}
                            />
                        </div>
                    ) : (
                        <IConUser
                            className="ant-avatar"
                            style={styleAvatarUser}
                            onClick={handleSwitchUserSetting}
                        />
                    )}
                </div>
                <div className="profile-info">
                    <div className="avatar_name">
                        <div className="hello text-body eng">
                            {(userInfo?.contact?.fullName || userInfo?.contact?.firstName) &&
                                "Hello"}{" "}
                        </div>
                        <div className="name text-sub-header eng">
                            {merchant?.advanceSettings?.tier?.isFullName
                                ? userInfo?.contact?.fullName
                                : userInfo?.contact?.firstName +
                                " " +
                                userInfo?.contact?.lastName}{" "}
                        </div>
                    </div>
                    <div className="user-actions">
                        <div
                            className="star"
                            onClick={() => {
                                history.push(PATH_MY_QR);
                            }}
                        >
                            <IconStarCircle stoke={modeColor} color={themes?.themeColor!} />
                        </div>
                        <div className="rank-layout">
                            <BudgeButton
                                onClick={handleDetail}
                                themeColor={themes?.themeColor!}
                                color={userInfo?.memberTier?.color || themeColor || ""}
                                icon={userInfo?.memberTier?.icon || ""}
                                tierName={userInfo?.memberTier?.tierName}
                            />
                        </div>
                    </div>
                </div>
                <div className="user-progress">
                    <StyledProgressBar
                        percentage={percentage}
                        color={themes?.themeColor!}
                        showInfo={false}
                    />
                    <div className="progress-info">
                        <p className="label text-small active-font eng">{userInfo?.memberCode}</p>
                        <StyledProgressText themeColor={themes?.themeColor!}>
                            {nextTiers.length > 0 && (
                                <p className="text text-small">
                                    {t("page.earn")}
                                    <span className="next-spendBath eng">
                                        {nextTierAmount} {merchant?.advanceSettings?.tier?.isTierBySale ? t("page.baht") : t("page._points")}
                                    </span>{" "}
                                    {t("page.upgrade")}{" "}
                                    <span className="eng">{nextTiers[0].membershipName}</span>
                                </p>
                            )}
                        </StyledProgressText>
                    </div>
                </div>

                <Button className="edit-profile-btn" onClick={openProfileForm}>
                    <EditIcon size={18} /> Edit Profile
                </Button>
            </div>
        </>
    );
};

const StyledProgressBar = styled(ProgressBar)`
    cursor: pointer;
`;
const StyledProgressText = styled.div<{ themeColor: string }>`
    .next-spendBath {
        color: ${(p) => p.themeColor};
    }
`;
